import React from "react";
import {
  GSSidePanelPage,
  GSItemList,
  GSEmptyList,
  GSActionBar
} from "golfstatus_react_components";
import { faChevronLeft, faSearch } from "@fortawesome/free-solid-svg-icons";
import { useMatch, useNavigate } from "react-router-dom";

//import scss
import "./tournament-reporting-documents.scss";
import { useNotificationBanner } from "../../../hooks/notificationHooks";
import SearchBar from "../../search-bar";
import { useDocuments } from "../../../forms/TournamentPrintoutForms";
import NavigationListItem from "../../navigation-list-item";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { downloadTournamentDocument } from "../../../reducers/tournamentSlice";

//Name the component
const TournamentReportingDocuments = (props) => {
  const [search, setSearch] = useState("");
  const match = useMatch("/:tournamentID/reporting/documents");
  const [
    teamDocuments,
    roundsDocuments,
    leaderboardDocuments,
    reportingDocuments,
  ] = useDocuments(match);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const notifications = [];

  const leftNavigation = () => {
    navigate(-1);
  };

  const getNavigation = () => {
    //Add Title to your component
    return {
      title: `Reporting Documents`,
      leftIcon: faChevronLeft,
      leftButtonClick: leftNavigation,
    };
  };
  const clearSearch = () => {
    setSearch("");
  };

  const gotoDocs = () => {
    navigate(`/${match.params.tournamentID}/documents?search=${search}`);
  };

  const gotoRoundDocs = () => {
    navigate(`/${match.params.tournamentID}/rounds/documents?search=${search}`);
  };

  const gotoLeaderboardDocs = () => {
    navigate(
      `/${match.params.tournamentID}/leaderboards/documents?search=${search}`
    );
  };

  const gotoTeamDocs = () => {
    navigate(
      `/${match.params.tournamentID}/leaderboards/documents?search=${search}`
    );
  };

  const getEmptySearchMessage = () => {
    let roundFilteredDocuments = getFilteredDocs(roundsDocuments);
    let leaderboardFilteredDocuments = getFilteredDocs(leaderboardDocuments);
    let teamFilteredDocuments = getFilteredDocs(teamDocuments);
    let availableActions = [
      {
        title: "Clear Search",
        onClick: clearSearch,
        type: "light-grey no-wrap",
      },
    ];
    if (roundFilteredDocuments.length > 0) {
      availableActions.push({
        title: "Search round documents",
        buttonIcon: faSearch,
        onClick: gotoRoundDocs,
        type: "light-grey no-wrap",
      });
    } else if (leaderboardFilteredDocuments.length > 0) {
      availableActions.push({
        title: "Search round documents",
        buttonIcon: faSearch,
        onClick: gotoLeaderboardDocs,
        type: "light-grey no-wrap",
      });
    } else if (teamFilteredDocuments.length > 0) {
      availableActions.push({
        title: "Search team documents",
        buttonIcon: faSearch,
        onClick: gotoTeamDocs,
        type: "light-grey no-wrap",
      });
    }else {
      availableActions.push({
        title: "Search all documents",
        buttonIcon: faSearch,
        onClick: gotoDocs,
        type: "light-grey no-wrap",
      });
    }
    return (
      <GSEmptyList
        title="We couldn’t find the document you’re looking for…"
        detail="Try changing the search term or search all documents."
        actions={availableActions}
      />
    );
  };

  const getEmptyTeamsMessage = () => {
    return (
      <GSEmptyList
        title="Team Documents."
        detail="When there are teams in the tournament, you can download documents pertaining to your team herre."
        actions={[
          {
            title: "Create team",
            onClick: gotoDocs,
            type: "black no-wrap",
          },
        ]}
      />
    );
  };

  const getMatchString = (doc) => {
    let matchString = `${doc.label} ${doc.details}`.toLowerCase();
    if (doc.documents) {
      doc.documents.forEach?.((d) => {
        matchString = `${matchString} ${getMatchString(d)}`;
      });
    }
    return matchString;
  };

  const searchMatch = (doc) => {
    return getMatchString(doc)?.includes?.(search?.toLowerCase());
  };

  const getFilteredDocs = (group) => {
    let filtered = group?.documents?.filter?.((doc) => searchMatch(doc));
    return filtered ?? [];
  };

  const downloadDocument = (item) => {
    if (item.disabled) {
      return;
    }
    dispatch(downloadTournamentDocument(item));
  };

  const getContent = () => {
    return (
      <gs-form>
        <GSActionBar type="form-header" header="Reporting Documents"/>
        <SearchBar search={search} setSearch={setSearch} placeholder="Search Documents…"></SearchBar>
        <GSItemList
          type="vertical"
          emptyMessage={
            reportingDocuments.documents.length === 0
              ? getEmptyTeamsMessage()
              : getEmptySearchMessage()
          }
          items={getFilteredDocs(reportingDocuments)}
          listItem={(item) => <NavigationListItem page={item} />}
          itemSelected={downloadDocument}
        />
      </gs-form>
    );
  };

  const timeoutAction = () => {};

  const [banner] = useNotificationBanner({ notifications, timeoutAction });

  return (
    //name the component tag
    <tournament-reporting-documents>
      <GSSidePanelPage
        header={getNavigation()}
        banner={banner}
        content={getContent()}
      ></GSSidePanelPage>
    </tournament-reporting-documents>
  );
};

//export the new namet
export default TournamentReportingDocuments;
